import ReactGA from 'react-ga'
import * as R from 'ramda'
import * as React from 'react'

function initializeAnalytics() {
    const analyticsId = process.env.REACT_APP_GOOGLE_ANALYTICS_ID

    const toDebug = R.isNil(process.env.REACT_APP_GOOGLE_ANALYTICS_DEBUG)
        ? false
        : JSON.parse(process.env.REACT_APP_GOOGLE_ANALYTICS_DEBUG)

    console.log("DOING ::: initializeAnalytics", analyticsId, toDebug)

    if (analyticsId) {
        ReactGA.initialize(analyticsId, {
            debug: toDebug,
            titleCase: false
        })
    }
}

initializeAnalytics()

export function lazyGA() {
    // console.log("DOING :::", "lazyGACalled", ReactGA)
    return ReactGA
}
export const logPageView = (history) => {
    history.listen((location) => {
        const page = location.pathname || window.location.pathname;
        ReactGA.set({ page: page });
        ReactGA.pageview(page);
        console.log(`Page View logged for: ${page}`);
    });
};

export const withTracker = (WrappedComponent) => {

    const trackPage = page => {
        ReactGA.set({
            page
        });
        ReactGA.pageview(page);
    };

    const HOC = props => {
        React.useEffect(() => trackPage(props.location.pathname), [
            props.location.pathname
        ]);

        return <WrappedComponent {...props} />;
    };

    return HOC;
};